import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Skills = () => {
  const { t } = useTranslation();
  return (
    <div className="max-w-2xl mx-auto my-auto">
      <h3 className="post-title">{t("Tools_&_Technologies")}</h3>
      <div className="flex flex-wrap justify-around my-5">
        {t("tools_tech", { returnObjects: true }).map((item, i) => (
          <motion.div
            key={i}
            className="skillCalc m-1 bg-purple-600 p-4 rounded flex justify-center items-center"
            initial={{
              opacity: 0,
              translateX: i % 2 === 0 ? -50 : 50,
              translateY: 50,
            }}
            animate={{ opacity: 1, translateX: 0, translateY: 0 }}
            transition={{ duration: 1, delay: i * 0.2 }}
            drag
            dragConstraints={{
              top: -0,
              right: 0,
              bottom: 0,
              left: -0,
            }}
            dragTransition={{ bounceStiffness: 500, bounceDamping: 20 }}
            dragElastic={1}
          >
            <h2 className="text-center post-text font-medium">{item.title}</h2>
          </motion.div>
        ))}
      </div>
      <h3 className="post-title">{t("Industry_Knowledge")}</h3>
      <div className="flex flex-wrap justify-around my-5">
        {t("industryKnowledge", { returnObjects: true }).map((item, i) => (
          <motion.div
            key={i}
            className="skillCalc m-1 bg-violet-600 p-4 rounded flex justify-center items-center"
            initial={{
              opacity: 0,
              translateX: i % 2 === 0 ? -50 : 50,
              translateY: 50,
            }}
            animate={{ opacity: 1, translateX: 0, translateY: 0 }}
            transition={{ duration: 1, delay: i * 0.2 }}
            drag
            dragTransition={{ bounceStiffness: 500, bounceDamping: 20 }}
            dragElastic={1}
            whileHover={{ cursor: "grab" }}
            whileTap={{ cursor: "grabbing" }}
          >
            <h2 className="text-center post-text font-medium">{item.title}</h2>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
